/**
 * Created by fengxuan on 17/2/22.
 */
let env = process.env.NODE_ENV;
if (env === "development") {
  module.exports = require('./app.dev');
} else {
  module.exports = require('./app.prod');
}



// WEBPACK FOOTER //
// ./src/config/index.js